class ProductFeaturesTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.handleClick);
      tab.addEventListener('keydown', this.handleKeydown);
    });

    const initialTab = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true') || this.tabs[0];
    this.activate(initialTab, { focus: false });

    this.querySelector('.features-tabs__panels')?.classList.remove('features-tabs__panels--not-ready');
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => {
      tab.removeEventListener('click', this.handleClick);
      tab.removeEventListener('keydown', this.handleKeydown);
    });
  }

  handleClick = (event) => {
    this.activate(event.currentTarget, { focus: false });
  };

  handleKeydown = (event) => {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    if (currentIndex === -1) return;

    let nextIndex = null;
    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activate(this.tabs[nextIndex], { focus: true });
  };

  activate(tab, { focus } = { focus: false }) {
    if (!tab) return;
    const targetId = tab.getAttribute('aria-controls');

    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id === targetId;
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    if (focus) tab.focus();
  }
}

if (!customElements.get('product-features-tabs')) {
  customElements.define('product-features-tabs', ProductFeaturesTabs);
}
